'use client'

import { GATEWAY_LIST_STATUS_TEST_IDS } from '@modules/gateways/gateways-test-ids.const'

import type { GatewayListStatus as GatewayListStatusModel } from '../../utils/resolveGatewayListStatus'
import { GatewayActiveState } from '../GatewayActiveState'

type GatewayListStatusProps = {
  status: GatewayListStatusModel
  className?: string
}

export function GatewayListStatus({ status, className }: GatewayListStatusProps) {
  return (
    <span data-testid={GATEWAY_LIST_STATUS_TEST_IDS.root}>
      <GatewayActiveState className={className} variant={status.variant} label={status.label} />
    </span>
  )
}
